import type {RouteLocationRaw} from 'vue-router';

/** A navigable entry in a table of contents with progress state */
export interface TableOfContentItem {
  id: string;
  index: number;
  state: TableOfContentItemState;
  title: string;
  link: RouteLocationRaw;
  isFaded?: boolean;
}

/** Navigation state of a table-of-contents entry */
export enum TableOfContentItemState {
  Current = 'current',
  Locked = 'locked',
  Completed = 'completed',
}
